module.exports = __webpack_public_path__ + "media/images/klarna_logo-26e25468df7ca4f20f16b4ebcb3a5143.png";